import React from 'react'
import { Table, Space, Button, Tooltip, Tag, theme } from 'antd'
import { CheckOutlined, EditOutlined, DeleteOutlined } from '@ant-design/icons'
import {
  formatReminderTitle,
  formatStaffInfo,
  getPriorityTag,
  formatDateTime,
  formatTimeUntilTag,
  getAcknowledgedBadge,
  getCategoryTag,
  getDepartmentTag
} from '../utils/formatters'
import { hexToRGBA } from '../../../../lib/utils'

const ReminderTable = ({ data, showTimeUntil = true, onAcknowledge, onEdit, onDelete }) => {
  const { token } = theme.useToken()

  const getColumns = () => {
    const columns = [
      {
        title: 'Title',
        dataIndex: 'reminderTitle',
        key: 'reminderTitle',
        render: (text, record) => formatReminderTitle(text, record.reminderId)
      },
      {
        title: 'Staff Member',
        dataIndex: 'staffName',
        key: 'staffName',
        render: (text, record) => (
          <Space direction='vertical' size={0}>
            <span>{text}</span>
            <span>{getDepartmentTag(record.department)}</span>
          </Space>
        )
      },
      {
        title: 'Category',
        dataIndex: 'category',
        key: 'category',
        render: (category) => getCategoryTag(category)
      },
      {
        title: 'Priority',
        dataIndex: 'priority',
        key: 'priority',
        render: (priority) => getPriorityTag(priority)
      },
      {
        title: 'Date/Time',
        dataIndex: 'reminderDate',
        key: 'reminderDate',
        render: (date) => formatDateTime(date),
        sorter: (a, b) => new Date(a.reminderDate) - new Date(b.reminderDate)
      },
      {
        title: 'Status',
        dataIndex: 'isAcknowledged',
        key: 'isAcknowledged',
        render: (isAcknowledged) => getAcknowledgedBadge(isAcknowledged)
      },
      {
        title: 'Actions',
        key: 'actions',
        render: (_, record) => (
          <Space size='small'>
            {!record.isAcknowledged && (
              <Tooltip title='Acknowledge'>
                <Button
                  icon={<CheckOutlined style={{ color: token.colorSuccess }} />}
                  size='small'
                  onClick={() => onAcknowledge(record)}
                  style={{
                    background: hexToRGBA(token.colorSuccess, 0.1),
                    borderColor: token.colorSuccess
                  }}
                />
              </Tooltip>
            )}
            <Tooltip title='Edit'>
              <Button
                icon={<EditOutlined style={{ color: token.colorPrimary }} />}
                size='small'
                onClick={() => onEdit(record)}
                style={{
                  background: hexToRGBA(token.colorPrimary, 0.1),
                  borderColor: token.colorPrimary
                }}
              />
            </Tooltip>
            <Tooltip title='Delete'>
              <Button
                icon={<DeleteOutlined style={{ color: token.colorError }} />}
                size='small'
                onClick={() => onDelete(record)}
                style={{
                  background: hexToRGBA(token.colorError, 0.1),
                  borderColor: token.colorError
                }}
              />
            </Tooltip>
          </Space>
        )
      }
    ]

    // Add time until column if needed
    if (showTimeUntil) {
      columns.splice(5, 0, {
        title: 'Time Until',
        key: 'timeUntil',
        render: (_, record) => formatTimeUntilTag(record.reminderDate)
      })
    }

    return columns
  }

  return <Table columns={getColumns()} dataSource={data} rowKey='reminderId' pagination={{ pageSize: 10 }} />
}

export default ReminderTable
